import { Link } from '@tanstack/react-router';

export function SiteFooter() {
  return (
    <footer className="py-8 px-6 border-t text-center text-sm text-muted-foreground">
      <div className="flex flex-wrap justify-center gap-x-6 gap-y-2 mb-2">
        <Link to="/pricing" className="hover:underline">
          Pricing
        </Link>
        <Link to="/terms" className="hover:underline">
          Terms of Service
        </Link>
        <Link to="/privacy" className="hover:underline">
          Privacy Policy
        </Link>
        <a href="mailto:yes-reply@nilboard.app" className="hover:underline">
          Contact
        </a>
      </div>
      <p>&copy; {new Date().getFullYear()} NilBoard. All rights reserved.</p>
    </footer>
  );
}
